module.exports = __webpack_public_path__ + "static/media/tasks-alt.4fba6fc1.svg";